<template>
    <div>
        <div id="map"></div>
    </div>
</template>

<script>
import mapdata from "./components/html5countrymap/mapdata.js"
import countrymap from "./components/html5countrymap/countrymap.js"
export default {
    comments: {
        mapdata,
        countrymap,
    },
}
</script>
